$(document).ready(function () {
	// Gets the video src from the data-src on each button
	var $videoSrc;
	$(".video-btn").on("click touch", function (e) {
		e.preventDefault();
		$videoSrc = $(this).data("src");
		$("#modal").addClass("video");
		$(".modal-body").addClass("video-body");

		$(".modal-body.video-body").html(
			'<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="' +
				$videoSrc +
				'?autoplay=1&amp;modestbranding=1&amp;showinfo=0" allowscriptaccess="always" allow="autoplay"></iframe></div>',
		);
	});

	$("h1 .Stars").on("click touch", function (e) {
		e.preventDefault();

		$("html, body").animate(
			{
				scrollTop: $("#avis-clients").offset().top,
			},
			500,
			function () {
				window.location.hash = "#avis-clients";
				$(".cd-auto-hide-header").removeClass("is-hidden");
			},
		);
	});

	$(".swiper-slide-ig").on("click touch", function (e) {
		e.preventDefault();
		window.open(
			$(
				e.target.closest(".swiper-slide-ig").children[0].children[0],
			).data("href"),
			"_blank",
		);
	});

	//Member Team click event & hover event

	$(".team.link").on("click touch", function () {
		if ($(this).hasClass("selectedTeamElement")) {
			$(".team").removeClass("opaciteteam");
			$(".team").removeClass("selectedTeamElement");
		} else {
			$(".team")
				.addClass("opaciteteam")
				.filter(this)
				.removeClass("opaciteteam");
			$(".team").removeClass("selectedTeamElement");
			$(this).addClass("selectedTeamElement");
		}
	});

	//All Sliders
	var el3 = document.getElementsByClassName("slider-photos")[0];
	var swiper3 = el3.getElementsByClassName("swiper-container")[0];
	var nx3 = el3.getElementsByClassName("swiper-button-next")[0];
	var pr3 = el3.getElementsByClassName("swiper-button-prev")[0];

	new Swiper(swiper3, {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: nx3,
			prevEl: pr3,
		},
		keyboard: {
			enabled: false,
			onlyInViewport: false,
		},
		autoplay: {
			delay: 5000,
		},
	});

	var el2 = document.getElementsByClassName(
		"slider-clients-parlent-de-nous",
	)[0];
	var swiper2 = el2.getElementsByClassName("swiper-container")[0];
	var nx2 = el2.getElementsByClassName("swiper-next")[0];
	var pr2 = el2.getElementsByClassName("swiper-prev")[0];

	new Swiper(swiper2, {
		slidesPerView:
			$(window).width() < 576
				? 1
				: $(window).width() < 1200
				? 2
				: $(window).width() < 1600
				? 3
				: 3,
		spaceBetween: 30,
		loop: false,
		navigation: {
			nextEl: nx2,
			prevEl: pr2,
		},
		pagination: {
			el: ".slider-clients-parlent-de-nous .swiper-pagination",
			clickable: true,
		},
		keyboard: {
			enabled: false,
			onlyInViewport: false,
		},
	});

	var showChar = 300;
	var ellipsestext = "...";
	var moretext = "Plus";
	var lesstext = "Moins";

	$(".showmore").each(function () {
		var content = $(this).html();

		if (content.length > showChar) {
			var c = content.substr(0, showChar);
			var h = content.substr(showChar, content.length - showChar);

			var html =
				c +
				'<span class="moreellipses">' +
				ellipsestext +
				'</span><span class="morecontent"><span>' +
				h +
				'</span>&nbsp;<a rel="nofollow" href="#" class="morelink">' +
				moretext +
				"</a></span>";

			$(this).html(html);
		}
	});

	$(".morelink").click(function () {
		if ($(this).hasClass("less")) {
			$(this).removeClass("less");
			$(this).html(moretext);
		} else {
			$(this).addClass("less");
			$(this).html(lesstext);
		}
		$(this).parent().prev().toggle();
		$(this).prev().toggle();
		return false;
	});

	var swiper = new Swiper(".bloc-nos-actualites .swiper-container", {
		slidesPerView:
			$(window).width() < 576
				? 1.1
				: $(window).width() < 768
				? 2.1
				: $(window).width() < 992
				? 2.1
				: $(window).width() < 1200
				? 3.1
				: $(window).width() < 1600
				? 3
				: 3,
		spaceBetween: 30,
		centerInsufficientSlides: true,
		loop: false,
		pagination: {
			el: ".bloc-nos-actualites .swiper-pagination",
			clickable: true,
		},
		keyboard: {
			enabled: false,
			onlyInViewport: false,
		},
	});

	$(".bloc-nos-actualites").css("visibility", "visible");
});
